import classNames from "classnames";

import styles from "./ToggleSwitch.module.scss";

export type ToggleSwitchOption = {
  label: string;
  value: string;
};

export type ToggleSwitchProps = {
  options: ToggleSwitchOption[];
  selectedValue: string;
  onChange: (value: string) => void;
  isDisabled?: boolean;
};

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ options, selectedValue, onChange, isDisabled }) => {
  const handleToggle = (value: string) => {
    onChange(value);
  };

  return (
    <div className={classNames(styles.toggleSwitch, { [styles.disabled]: isDisabled })}>
      {options.map((option) => (
        <button
          key={option.value}
          className={classNames(styles.option, {
            [styles.selected]: option.value === selectedValue,
          })}
          disabled={isDisabled}
          onClick={() => handleToggle(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
